import { Card } from "primereact/card";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../../../../shared/Fetch";
import { JVInput } from "../../../../../shared/JVInput";
import { JVDropdown } from "../../../../../shared/JVDropdown";
import { IDesignationMastDropdown } from "../../../../../models/IDropdown";
import { JVInputMask } from "../../../../../shared/JVInputMask";

interface ISubVendorAccountDetailsMast {
    id?: number,
    name?: number,
    email?: number,
    phone?: number,
    contact_Person_ID?: number,
    designation?: number,
    designation_Name?: string,
}

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any,
    reload1: boolean,
    setReload: (is: boolean) => void,
}

const schema = yup.object({
    name: yup.string().required("Name is required*").min(3),
    email: yup.string().required("EmailID is required*").email(),
    phone: yup.string().required("Phone No is required*"),
     designation: yup.number().min(1, "Designation is required*").required("Designation is required*"),
});

export const SubVendorAccountDetails = (props: IProps) => {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const toast = useRef<any>(null);
    const [designations, setDesignations] = useState<Array<IDesignationMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<ISubVendorAccountDetailsMast>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    const saveToDB = async (body: ISubVendorAccountDetailsMast) => {
        setLoading(true);
        console.log(data?.accountDetails?.id)
        const method = props?.singleData?.accountDetails?.id ? "PUT" : "POST";
        const message = props?.singleData?.accountDetails?.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("ResourceSub_Vendor_Contact_Person_Mast/account", method, body, null, null);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.hideDialog();
            props.setReload(!props.reload1);
            setLoading(false);

        } else setLoading(false);

    };

    function onSubmit(body: ISubVendorAccountDetailsMast) {
        body.contact_Person_ID = body?.contact_Person_ID ? body?.contact_Person_ID : data?.contact_Person_ID;
        saveToDB(body);
    };

    const loadDesignations = async () => {
        const response = await Fetch("Dropdown/designation", "GET", null, null, null);
        if (response) {
            const data: Array<IDesignationMastDropdown> = await response.json();
            setDesignations(data);
        }
    };


    const onHide = () => {
        // props.hideDialog();
        // reset(EmptyClientContactPerson);
        // setVCompanyInfo(undefined);
    };

    useEffect(() => {
        if (props?.singleData?.accountDetails?.id) {
            reset(props?.singleData?.accountDetails);
        }
    }, [props?.singleData]);

    useEffect(() => {
    }, []);

    useEffect(() => {
        loadDesignations();
    }, []);


    return (
        <>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput required label="Name" control={control} name="name" error={errors.name?.message} />
                    <JVInput required label="Email ID" control={control} name="email" error={errors.email?.message} />
                    <JVInputMask mask="(999) 999-9999" required label="Phone No." control={control} name="phone" error={errors.phone?.message} />
                    <JVDropdown required label="Designation" control={control} name="designation" error={errors.designation?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                        <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                    </div>

                </form>
            </Card>
            <Toast ref={toast} />
        </>
    );
}